module.exports = __webpack_public_path__ + "img/header-illustration.5d2a9258.svg";